import { useEffect, useState } from "react"
import { UmbracoNode } from "../../models/UmbracoNode"
import { fetchAPI } from "../../Helpers/utils";
import RelatedBlogPostItem from "./RelatedBlogPostItem";

export type RelatedBlogPostsModel = {
  title: string,
  id: number,
  numberOfPosts: number
}

export default function RelatedBlogPosts({ title, id, numberOfPosts }: RelatedBlogPostsModel) {
  const [items, setItems] = useState<UmbracoNode[]>([]);

  useEffect(() => {
    async function getData() {
      const data = await fetchAPI<any>(`/api/blog/related/${id}?numberOfPosts=${numberOfPosts}`);
      if (data.result) {
        setItems(data.result);
      }
    }

    getData();
  }, [id, numberOfPosts]);

  return (
    <div className="related-blog">
        <div className="title"><h6>{title}</h6></div>
        <ul className="list">
          { items.length > 0 && items.map((item) => (
            <li>
              <RelatedBlogPostItem 
                key={`blogPost-${item.id}`} 
                node={item} defaultImage={null} />
            </li>
          ))}
        </ul>
    </div>
  )
}